import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

// Scroll reveal: fades content up once it enters the viewport.
export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div", ...rest }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </Tag>
  );
};
